import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import m from "../../utils/mergeCSS";
import symbol from "./BlocketSymbol.svg.js";
import symbolInverted from "./BlocketSymbolInverted.svg.js";
var styles = Immutable.from({
  logo: {
    height: 'auto',
    border: 'none'
  }
});

var BlocketSymbol = function BlocketSymbol(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 35 : _ref$width,
      style = _ref.style,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted;
  var imageSource = inverted ? symbolInverted : symbol;
  return /*#__PURE__*/React.createElement("img", {
    src: imageSource,
    style: m(styles, {
      width: width
    }, {
      height: width
    }, style),
    alt: "Blocket"
  });
};

BlocketSymbol.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The desired width in px of the symbol. The height will automatically be adjusted by the width.
   */
  width: PropTypes.number,

  /**
   * Invert the colors of the symbol
   */
  inverted: PropTypes.bool,
  style: PropTypes.object
} : {};
export default BlocketSymbol;
//# sourceMappingURL=BlocketSymbol.js.map